// Verification checkout: submit a sales order through the real Epicor push, read
// it back, and clean it up.
//
// These endpoints write to the production ERP. The customer allowlist and the
// value cap that make that bounded are enforced server-side, in
// waterco.epicor_order_guard, and are reported by getTestOrderConfig so the page
// can state its own constraints rather than discovering them in a rejection.
import syncApi from './syncApi';

export const getTestOrderConfig = () =>
  syncApi.get('/epicor/test-orders/config').then((r) => r.data);

export const listShipVia = (company, refresh = false) =>
  syncApi
    .get('/epicor/ship-via', { params: { company, refresh } })
    .then((r) => r.data);

// Countries for the one-time-address dropdown. OTSCountryNum is an integer FK
// to Erp.Country, so the choices come from Epicor, not a hardcoded list.
export const listCountries = (company, refresh = false) =>
  syncApi
    .get('/epicor/countries', { params: { company, refresh } })
    .then((r) => r.data);

export const getCustomerDetail = (company, custNum) =>
  syncApi.get(`/epicor/customers/${company}/${custNum}`).then((r) => r.data);

export const getLiveCredit = (company, custNum) =>
  syncApi
    .get(`/epicor/customers/${company}/${custNum}/credit`)
    .then((r) => r.data);

// The credit reservation a submission is holding. status='all' so a landed or
// cancelled hold still shows its terminal state rather than vanishing.
export const getReservation = (company, externalRef) =>
  syncApi
    .get('/epicor/credit/reservations', {
      params: { company, external_ref: externalRef, status: 'all', limit: 1 },
    })
    .then((r) => (r.data.reservations || [])[0] || null);

// What the checkout shows before the order is placed: the ready-to-ship and
// backorder split, freight from the postcode zone table, GST and the pay-today
// against charged-later totals. Indicative -- Epicor prices the order when the
// push commits it -- and read-only, so it answers even when the write gate is
// shut and nothing can be submitted.
export const quoteOrder = (payload) =>
  syncApi.post('/epicor/orders/quote', payload).then((r) => r.data);

export const submitOrder = (payload) =>
  syncApi.post('/epicor/orders/submit', payload).then((r) => r.data);

export const listSubmissions = (params) =>
  syncApi.get('/epicor/orders/submissions', { params }).then((r) => r.data);

export const reconcileOrders = (params) =>
  syncApi.post('/epicor/orders/reconcile', null, { params }).then((r) => r.data);

// verify=true adds the ODBC read that answers whether the correlation stamp
// survived the commit. That is the question the whole recovery mechanism rests
// on, so it is on by default and only skipped when re-polling.
export const readOrderBack = (company, orderNum, verify = true) =>
  syncApi
    .get(`/epicor/orders/epicor/${company}/${orderNum}`, { params: { verify } })
    .then((r) => r.data);

export const closeOrder = (company, orderNum) =>
  syncApi
    .post(`/epicor/orders/epicor/${company}/${orderNum}/close`)
    .then((r) => r.data);

export const reopenOrder = (company, orderNum) =>
  syncApi
    .post(`/epicor/orders/epicor/${company}/${orderNum}/reopen`)
    .then((r) => r.data);

export const voidOrder = (company, orderNum) =>
  syncApi
    .post(`/epicor/orders/epicor/${company}/${orderNum}/void`)
    .then((r) => r.data);

// confirm travels in the body because the server requires it. A typed
// confirmation in the form alone would be cosmetic on an endpoint reachable with
// an API key.
export const deleteOrder = (company, orderNum) =>
  syncApi
    .delete(`/epicor/orders/epicor/${company}/${orderNum}`, {
      data: { confirm: true },
    })
    .then((r) => r.data);
